import { useEffect, useState } from 'react';
import { useFeatureFlags } from './useFeatureFlags';

// Resolves the global `enable-interior-designer` feature flag. Gates the whole
// interior-designer surface (Design Studio nav, catalog, projects). `loading`
// lets callers avoid flashing a "not available" state before the flag resolves.
export const useInteriorDesignerEnabled = (): { enabled: boolean; loading: boolean } => {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [FeatureFlagFunctions] = useFeatureFlags();

    useEffect(() => {
        let active = true;
        FeatureFlagFunctions.get('enable-interior-designer').then((value: boolean) => {
            if (!active) return;
            setEnabled(value);
            setLoading(false);
        });
        return () => { active = false; };
    }, []);

    return { enabled, loading };
};
